import * as React from "react";
function findPathParent(obj, arr) {
  if (!obj)
    return;
  arr.push(obj.type);
  const children = obj.props?.children;
  if (obj.type === "path" && !children) {
    return arr.pop();
  } else if (typeof children === "object") {
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const result = findPathParent(children[i], arr);
        if (result) {
          break;
        }
      }
    } else {
      findPathParent(children, arr);
    }
  } else {
    arr.pop();
  }
}
function addNewStyle(newStyle) {
  let styleElement = document.getElementById("styles_js");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.id = "styles_js";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}
function changePathStyle(props, arr, id) {
  if (!props)
    return;
  const str = arr.join(" ");
  const root = arr[0];
  const others = arr.slice(1);
  if (props.color) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props.color + "}");
  }
  if (props["data-hovercolor"]) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovercolor"] + "}");
  }
  if (props["data-activecolor"]) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activecolor"] + "}");
  }
  if (Array.isArray(props["data-twotonecolor"])) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-twotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-twotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-hovertwotonecolor"])) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovertwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-hovertwotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-activetwotonecolor"])) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activetwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-activetwotonecolor"][1] + "}");
  }
  if (props.width) {
    addNewStyle(root + "#" + id + "{width: " + props.width + "}");
  }
  if (props.height) {
    addNewStyle(root + "#" + id + "{height: " + props.height + "}");
  }
}
const isArrayContainsElement = (arr1, arr2) => {
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      return true;
    }
  }
  return false;
};
const OPTIONS = ["color", "data-activecolor", "data-hovercolor", "data-twotonecolor", "data-hovertwotonecolor", "data-activetwotonecolor", "width", "height"];
const SvgLeftArrow = (props) => {
  const isSetOptions = isArrayContainsElement(Object.keys(props), OPTIONS);
  const svg = /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", id: "left-arrow_svg_plugin_32753", ...props }, /* @__PURE__ */ React.createElement("g", { id: "direction/left" }, /* @__PURE__ */ React.createElement("g", { id: "Union" }, /* @__PURE__ */ React.createElement("path", { d: "M3.95482 6.00023L7.72371 9.76911C7.78229 9.82769 7.78228 9.92266 7.72371 9.98124L7.19338 10.5116C7.1348 10.5702 7.03982 10.5702 6.98124 10.5116L2.73484 6.26516C2.58839 6.11872 2.58839 5.88128 2.73484 5.73483L6.98176 1.48836C7.04034 1.42978 7.13532 1.42978 7.1939 1.48836L7.72423 2.01869C7.7828 2.07727 7.7828 2.17224 7.72423 2.23082L3.95482 6.00023Z" }))));
  if (isSetOptions) {
    const parents = [];
    findPathParent(svg, parents);
    const id = svg.props.id;
    changePathStyle(props, parents, id);
  }
  return svg;
};
export default SvgLeftArrow;
